import PropTypes from "prop-types"
import Panel from "../panel"
import GroupPanel from "../group-panel"
import { ITEMS_COLORS } from "helpers/comparison"
import LoadingWrapper from "components/loading-wrapper"
import Loading from "../loading"
import Error from "../error"
import "./styles.scss"

function Summary({ basketSummaryData, smartTradeSummaryData, setSelectedGroup, selectedGroup, groups, status, dispatch, smartLabel }) {
  const loadingComponent = <Loading />
  const errorComponent = <Error text="An error occured while performing the smart trade, please change the rules and try again." />

  return <div className="components_smart-trade-panel-summary">
    <LoadingWrapper status={status} loadingComponent={loadingComponent} errorComponent={errorComponent}>
      {basketSummaryData && <>
        <h2>Basket</h2>
        <Panel items={basketSummaryData} />
      </>}
      <h2>Smart {smartLabel}</h2>
      <GroupPanel dispatch={dispatch} setGroup={setSelectedGroup} color={selectedGroup === "topFactors" ? null : ITEMS_COLORS[0]} selectedGroup={selectedGroup} groups={groups} items={smartTradeSummaryData} />
    </LoadingWrapper>
  </div>
}

Summary.propTypes = {
  basketSummaryData: PropTypes.array,
  smartTradeSummaryData: PropTypes.array.isRequired,
  selectedGroup: PropTypes.string.isRequired,
  setSelectedGroup: PropTypes.func.isRequired,
  groups: PropTypes.array.isRequired,
  status: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  smartLabel: PropTypes.string.isRequired,
}

export default Summary
